<template>
  <div class="overview-clamped-text">
    <p
      ref="text"
      :class="[textClass, { 'overview-clamp': !expanded }]"
      :style="{ '--overview-clamp-lines': String(lines) }"
    >{{ text }}</p>
    <!-- Only when the clamp actually cut something off; once open it stays to close it. -->
    <button
      v-if="expanded || clamped"
      type="button"
      class="overview-preview-toggle"
      :aria-expanded="String(expanded)"
      @click="expanded = !expanded"
    >{{ expanded ? $t('overview_preview.show_less') : $t('overview_preview.show_more') }}</button>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { OVERVIEW_LINES } from '../overviewSectionPreview'
import { isClamped } from '../overviewPreviewDom'

/**
 * A long text capped at a few lines (OVERVIEW_LINES.description_lines), with its
 * own Show more / Show less when — and only when — the cap hid some of it. The
 * Vue side of the server pages' data-overview-clamp (utils/overviewPreviewDom.ts).
 */
const props = withDefaults(defineProps<{
  text: string
  lines?: number
  textClass?: string
}>(), { lines: OVERVIEW_LINES.description_lines, textClass: '' })

const text = ref<HTMLElement | null>(null)
const expanded = ref(false)
const clamped = ref(false)

function measure (): void {
  if (!expanded.value && text.value) clamped.value = isClamped(text.value)
}

watch(() => props.text, async () => {
  expanded.value = false
  await nextTick()
  measure()
})

onMounted(() => {
  measure()
  window.addEventListener('resize', measure)
})
onBeforeUnmount(() => window.removeEventListener('resize', measure))
</script>
